const checkIsObject = (object) =>
  typeof object === 'object' && !Array.isArray(object) && object !== null

export default checkIsObject
